import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function groupsReducer(state = initialState.groups, action) {
    switch (action.type) {
        case types.CREATE_GROUP:
            let ceateStateArray = []
            state.userGroups.map((group) => {
                if (group.id != action.group.id) {
                    var g = JSON.parse(JSON.stringify(group));
                    ceateStateArray.push(g);
                }
            });
            ceateStateArray.push(action.group);
            return {
                ...state,
                userGroups: ceateStateArray
            };
            break;
        case types.LOAD_GROUP:
            let loadStateArray = []
            if (state.userGroups.length == 0) {
                loadStateArray.push(action.group);
            } else {
                state.userGroups.map((group) => {
                    if (group.id != action.group.id) {
                        var g = JSON.parse(JSON.stringify(group));
                        loadStateArray.push(g);
                    }
                    else if (group.id === action.group.id) {
                        loadStateArray.push(action.group);
                    }
                });
            }
            return {
                ...state,
                userGroups: loadStateArray
            };
            break;
        case types.EDIT_GROUP:
            let editStateArray = []
            state.userGroups.map((group) => {
                if (group.id != action.group.id) {
                    var g = JSON.parse(JSON.stringify(group));
                    editStateArray.push(g);
                }
                else {
                    editStateArray.push(action.group);
                }
            });
            return {
                ...state,
                userGroups: editStateArray
            };
        case types.UPDATE_GROUP_AVATAR:
            let avatarStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.avatar.groupId) {
                    g.avatarAvailable = true;
                    g.avatarVersion = action.avatar.version;
                }
                avatarStateArray.push(g);
            });
            return {
                ...state,
                userGroups: avatarStateArray
            };
        case types.UPDATE_GROUP_BANNER:
            let bannerStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.banner.groupId) {
                    g.bannerAvailable = true;
                    g.bannerVersion = action.banner.version;
                }
                bannerStateArray.push(g);
            });
            return {
                ...state,
                userGroups: bannerStateArray
            };
        case types.LOAD_USER_GROUPS:
            return {
                ...state,
                userGroups: action.results.groups,
                pendingGroups: action.results.pendingGroups,
                userGroupsInitialised: true
            };
        case types.SHARE_ROUTE:
            let shareStateArray = []
            state.userGroups.map((group) => {
                if (group.id == action.group.id) {
                    var shares = [];
                    if (group.sharedRoutes) {
                        group.sharedRoutes.map((r) => {
                            shares.push(r);
                        })
                    }
                    shares.push(action.route);
                    var g = JSON.parse(JSON.stringify(group));
                    g.sharedRoutes = shares;
                    shareStateArray.push(g);
                } else {
                    shareStateArray.push(group);
                }
            });
            return {
                ...state,
                userGroups: shareStateArray
            };
        case types.REMOVE_ROUTE_SHARE_OPTIMISTIC:
            let unShareStateArray = []
            state.userGroups.map((group) => {
                var shares = []
                if (group.sharedRoutes) {
                    group.sharedRoutes.map((r) => {
                        if (group.id == action.group.id) {
                            if (r.id != action.route.id) {
                                shares.push(r);
                            }
                        } else {
                            shares.push(r);
                        }
                    })
                }
                var g = JSON.parse(JSON.stringify(group));
                g.sharedRoutes = shares;
                unShareStateArray.push(g);
            });
            return {
                ...state,
                userGroups: unShareStateArray
            };
        case types.ADD_USER_GROUP:
            let addUserStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.members.push(action.user);
                } 
                addUserStateArray.push(g);
            });
            return {
                ...state,
                userGroups: addUserStateArray
            };
        case types.REMOVE_USER_GROUP:
            let removeUserStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    var newMembers = [];
                    group.members.map(member => {
                        if (member.userId.toUpperCase() != action.userId.toUpperCase()) {
                            newMembers.push(member); 
                        }
                    })
                    g.members = newMembers; 
                } else {
                    g.members = group.members;
                }
                removeUserStateArray.push(g);
            });
            return {
                ...state,
                userGroups: removeUserStateArray
            };
        case types.MAKE_USER_ADMIN_GROUP:
            let makeAdminUserStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.administrators.push(action.user);
                    var newMembers = [];
                    group.members.map(member => {
                        if (member.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(member);
                        }
                    })
                    g.members = newMembers;
                }
                else {
                    g.members = group.members;
                }
                makeAdminUserStateArray.push(g);
            });
            return {
                ...state,
                userGroups: makeAdminUserStateArray
            };
        case types.REVOKE_USER_ADMIN_GROUP:
            let revokeAdminUserStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.members.push(action.user);
                    var newMembers = [];
                    group.administrators.map(admin => {
                        if (admin.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(admin);
                        }
                    })
                    g.administrators = newMembers;
                }
                else {
                    g.administrators = group.administrators;
                }
                revokeAdminUserStateArray.push(g);
            });
            return {
                ...state,
                userGroups: revokeAdminUserStateArray
            };
        case types.REQUEST_MEMBERSHIP_GROUP:
            let memberRequestStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.memberRequests.push(action.user);
                }
                memberRequestStateArray.push(g);
            });
            return {
                ...state,
                userGroups: memberRequestStateArray
            };
        case types.CONFIRM_MEMBERSHIP_GROUP:
            let confirmMemberStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.members.push(action.user);
                    var newMembers = [];
                    group.memberRequests.map(member => {
                        if (member.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(member);
                        }
                    })
                    g.memberRequests = newMembers;
                }
                else {
                    g.memberRequests = group.memberRequests;
                }
                confirmMemberStateArray.push(g);
            });
            return {
                ...state,
                userGroups: confirmMemberStateArray
            };
        case types.REJECT_MEMBERSHIP_GROUP:
            let rejectMemberStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.rejectedMemberRequests.push(action.user);
                    var newMembers = [];
                    group.memberRequests.map(member => {
                        if (member.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(member);
                        }
                    })
                    g.memberRequests = newMembers;
                }
                else {
                    g.memberRequests = group.memberRequests;
                }
                rejectMemberStateArray.push(g);
            });
            return {
                ...state,
                userGroups: rejectMemberStateArray
            };
        case types.MEMBERSHIP_REJECTION_CLEARED:
            let clearRejectionStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    var newMembers = [];
                    group.rejectedMemberRequests.map(member => {
                        if (member.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(member);
                        }
                    })
                    g.rejectedMemberRequests = newMembers;
                } else {
                    g.rejectedMemberRequests = group.rejectedMemberRequests;
                }
                clearRejectionStateArray.push(g);
            });
            return {
                ...state,
                userGroups: clearRejectionStateArray
            };
        case types.MEMBERSHIP_REJECTION_OVERTURNED:
            let overturnRejectionStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.members.push(action.user);
                    var newMembers = [];
                    group.rejectedMemberRequests.map(member => {
                        if (member.userId.toUpperCase() != action.user.userId.toUpperCase()) {
                            newMembers.push(member);
                        }
                    })
                    g.rejectedMemberRequests = newMembers;
                }
                else {
                    g.rejectedMemberRequests = group.rejectedMemberRequests;
                }
                overturnRejectionStateArray.push(g);
            });
            return {
                ...state,
                userGroups: overturnRejectionStateArray
            };
        case types.ARCHIVE_GROUP:
            let archiveStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.archived = true;
                }
                archiveStateArray.push(g);
            });
            return {
                ...state,
                userGroups: archiveStateArray
            };
        case types.REACTIVATE_GROUP:
            let reactivateStateArray = []
            state.userGroups.map((group) => {
                var g = JSON.parse(JSON.stringify(group));
                if (group.id == action.groupId) {
                    g.archived = false;
                }
                reactivateStateArray.push(g)
            });
            return {
                ...state,
                userGroups: reactivateStateArray
            };
        case types.LOGOUT_SUCCESS, types.RESET_GROUPS:
            return initialState.groups;
        default:
            return state;
    }
}


/*GROUPS

export const CREATE_GROUP = "CREATE_GROUP";
export const LOAD_GROUPS = "LOAD_GROUPS";
export const LOAD_GROUP = "LOAD_GROUP";
export const EDIT_GROUP = "LOAD_GROUP";
export const ARCHIVE_GROUP = "LOAD_GROUP";
export const ADD_USER_GROUP = "ADD_USER_GROUP";
export const REMOVE_USER_GROUP = "REMOVE_USER_GROUP";
export const MAKE_USER_ADMIN_GROUP = "MAKE_USER_ADMIN_GROUP";
export const REVOKE_USER_ADMIN_GROUP = "REVOKE_USER_ADMIN_GROUP";

NEW --

export const REQUEST_MEMBERSHIP_GROUP = "REQUEST_MEMBERSHIP_GROUP";
export const CONFIRM_MEMBERSHIP_GROUP = "CONFIRM_MEMBERSHIP_GROUP";
export const REJECT_MEMBERSHIP_GROUP = "REJECT_MEMBERSHIP_GROUP";

//{ id: group.id, name: group.name, description: group.description, ownerId: group.ownerId, friendlyUrl: group.friendlyUrl, private: group.private, avatarAvailable: group.avatarAvailable, sharedRoutes: group.sharedRoutes, members: group.members, administrators: group.administrators, memberRequests: group.memberRequests, rejectedMemberRequests: group.rejectedMemberRequests }

*/


// WEBPACK FOOTER //
// ./src/redux/reducers/groupsReducer.js